import React, { useState } from "react";
import Header from "../components/manageUsers/Header";
import ManageUserTableOverview from "../components/manageUsers/ManageUserTableOverview";

const ManageUsers = () => {
   const [searchTerm, setSearchTerm] = useState("");
  return (
    <div className="px-4 py-4">
      <Header />
      <ManageUserTableOverview 
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};

export default ManageUsers;
